//React
import { FunctionComponent, useEffect } from "react";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectIsAppLoaded } from "../../../system/redux/selectors/select-app-loaded";
import { selectSelectedFacets } from "../../redux/selectors/select-selected-facets";

//Constants
import allFacets from "../../../facets/constants/all-facets";
import { FacetTypes } from "../../../facets/constants/facet-types-enum";

//Models
import { RangeValues } from "../../../facets/models/types/type-range-values";

//Util
import { getFacetFromFieldName } from "../../../facets/functions/get-facet-from-field-name";
import { getFacetUrlParamName } from "../../../facets/functions/url/get-facet-url-param-name";
import { addUrlHashParam } from "../../../system/functions/url/add-url-hash-value";

/** Updates the URL with the currently selected facets */
export const UrlManagerFacets: FunctionComponent = (props) => {
	//State Values
	const appLoaded = useAppSelector(selectIsAppLoaded);
	const selectedFacets = useAppSelector(selectSelectedFacets);

	useEffect(() => {
		if (!appLoaded) {
			return;
		}

		var currentUrl = new URL(window.location.href);

		//Loop through the params and remove all the facet params
		var currentHashParams = new URLSearchParams(
			currentUrl.hash.replace("#", ""),
		);
		var hashKeys = [...currentHashParams.keys()];

		for (let index = 0; index < hashKeys.length; index++) {
			const key = hashKeys[index];
			if (key.toLowerCase().startsWith("f:")) {
				currentHashParams.delete(key);
			}
		}

		currentUrl.hash = currentHashParams.toString();

		//If no facets are selected do not do anything
		var numberOfSelectedFacets = Object.entries(selectedFacets).length;

		if (numberOfSelectedFacets > 0) {
			let sep = "";

			//Loop through the selected facets and add them to the url
			for (
				let index = 0;
				index < Object.entries(selectedFacets).length;
				index++
			) {
				const selectedFacet = Object.entries(selectedFacets)[index];

				var fieldName = selectedFacet[0];
				var facet = getFacetFromFieldName(fieldName, allFacets);

				if (facet === null) {
					continue;
				}

				var urlParamName = getFacetUrlParamName(fieldName, allFacets);

				var values = "";

				switch (facet.type) {
					case FacetTypes.Number:
						var numberFacet = selectedFacet[1] as number;

						values = numberFacet.toString();

						break;

					case FacetTypes.Range:
						var selectedRangeFacet = selectedFacet[1] as RangeValues;

						//If the selected range is the whole range do not add it to the URL
						//CF V2 TODO
						// if (
						// 	selectedRangeFacet[0] === selectedRangeFacet.selectedRange.lowValue &&
						// 	selectedRangeFacet[1] === selectedRangeFacet.selectedRange.highValue
						// ) {
						// 	continue;
						// }

						values = selectedRangeFacet[0] + "," + selectedRangeFacet[1];

						break;

					case FacetTypes.Text:
						var textFacet = selectedFacet[1] as string[];

						var commaSep = "";

						for (let index = 0; index < textFacet?.length; index++) {
							const value = textFacet[index];

							values += commaSep + value;
							commaSep = ",";
						}
						break;
				}

				if (values) {
					currentUrl = addUrlHashParam(
						currentUrl,
						"f:" + urlParamName,
						"[" + values + "]",
					);
				}
			}
		}

		//currentUrl.hash = decodeURIComponent(currentUrl.hash);
		window.history.replaceState({}, window.document.title, currentUrl);
	}, [selectedFacets, appLoaded]);

	return null;
};
